import { Page } from "shared/react";
import { MESSAGES_MAX } from "shared/schema";
import { useGroupContext } from "./GroupContext.js";
import { GroupShortHeader } from "./GroupShortHeader.js";
import { PossibleMessageForm } from "./MessageForm.js";
import { MessageList } from "./MessageList.js";

export function MessagesPage(): React.ReactElement {
	const { id: gid } = useGroupContext();
	return (
		<Page title="Messages" path="./messages">
			<GroupShortHeader />
			<MessageList
				query={{
					gid,
					thread: null,
					$order: "!date",
					$limit: MESSAGES_MAX,
				}}
			/>
			<PossibleMessageForm thread={null} />
		</Page>
	);
}
